export const CHIP_VARIANTS = {
  outlined: 'outlined',
  fulfilled: 'fulfilled',
} as const;
